<template>
  <div class="wg-row" style="justify-content:center;">
    
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  created() {
    this.$Progress.finish();
  }
}
</script>

<style lang="scss" scoped>

</style>
